module.exports = __webpack_public_path__ + "img/OIP.d6b79eb6.jpeg";